// When the console asks again for a new password after an administrator set
// it (user.must_change_password). "Later" holds it off for a day on this
// browser; without that the dialog reopened over the page on every load.

const SNOOZE_MS = 24 * 60 * 60 * 1000;

const key = (tenant: string | null, userId: number) => `dsshield_password_prompt_later:${tenant ?? ''}:${userId}`;

/** True when the prompt may open: never snoozed, or the snooze is over. */
export function passwordPromptDue(tenant: string | null, userId: number, now = Date.now()): boolean {
  try {
    const until = Number(localStorage.getItem(key(tenant, userId)));
    return !until || now >= until;
  } catch {
    return true;
  }
}

/** Holds the prompt off for a day. */
export function snoozePasswordPrompt(tenant: string | null, userId: number, now = Date.now()): void {
  try {
    localStorage.setItem(key(tenant, userId), String(now + SNOOZE_MS));
  } catch {
    /* storage blocked: the prompt opens again next load */
  }
}

/** Forgets the snooze, after the password changed. */
export function clearPasswordPromptSnooze(tenant: string | null, userId: number): void {
  try {
    localStorage.removeItem(key(tenant, userId));
  } catch {
    /* nothing stored */
  }
}
